<script setup lang="ts">
type ChartLegendSeriesIdentifierProps = {
  title?: string;
  color?: string;
  symbol?: string;
  size?: number;
  oneLine?: boolean;
  enumeration?: boolean;
};

const props = withDefaults(defineProps<ChartLegendSeriesIdentifierProps>(), {
  title: undefined,
  color: undefined,
  symbol: undefined,
  size: 24,
  oneLine: true,
  enumeration: false,
});

const lineWidth = props.size * 2;
const lineStrokeWidth = 3;
const linePadding = lineStrokeWidth / 2;
const svgWidth = lineWidth + linePadding * 2;
</script>

<template>
  <div
    v-if="!!symbol && !!color"
    class="chart-legend-series-identifier"
    :class="oneLine ? 'oneline' : ''"
  >
    <div class="svg-container">
      <svg class="series" :width="svgWidth" :height="size">
        <line
          v-if="!enumeration"
          :x1="linePadding"
          :x2="lineWidth"
          :y1="size / 2"
          :y2="size / 2"
          :stroke="color"
          :stroke-width="lineStrokeWidth"
        />

        <path class="symbol-path" :d="symbol" :fill="color" :transform="`translate(${19}, ${6})`" />
      </svg>
    </div>
    <template v-if="oneLine">
      <span v-if="title" class="title">
        {{ title }}
      </span>
    </template>
    <template v-else>
      <div v-if="title" class="title">
        {{ title }}
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.chart-legend-series-identifier {
  &.oneline {
    display: flex;
    align-items: start;
    gap: 0.5em;
  }

  .svg-container {
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }

  .series {
    line {
      stroke-linecap: round;
    }
  }
}
</style>
